enum Route {
  Home = 'Home',
  CallCenter = 'CallCenter',
  PhoneSim = 'PhoneSim',
  NotFound = 'NotFound',
}

export { Route };
